module.exports = __webpack_public_path__ + "static/media/icon-upload-disabled.a6827fac.svg";